import { render, staticRenderFns } from "./RingItem.vue?vue&type=template&id=ee0fba16&scoped=true&"
import script from "./RingItem.vue?vue&type=script&lang=js&"
export * from "./RingItem.vue?vue&type=script&lang=js&"
import style0 from "./RingItem.vue?vue&type=style&index=0&id=ee0fba16&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee0fba16",
  null
  
)

export default component.exports